export const PlanIds = Object.freeze({
    SPECIAL: 4,
    TRIAL: 3,
    MONTHLY: 2,
    ANNUAL: 1,
});
